import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  table: {
    height: '100%',
    overflowY: 'auto',
  },
}));